module.exports = __webpack_public_path__ + "img/7c2dfc1.jpg";